<template>
  <select class="SportHeader-styles-drop-down" v-model="selected">
    <option value="standard" :value="m.e" v-for="m in markets">
      {{ m.name }}
    </option>
  </select>
</template>

<script>
export default {
  name: 'marketSelect',
  props: ['sport', 'live', 'default', 'id'],
  data () {
    return {
      markets: [],
      selected: 0,
      EventInterval: null,
      s: {}
    }
  },
  beforeDestroy() {
    //clearInterval(this.EventInterval)
  },
  mounted () {
    this.fetchMarket()

    this.selected = this.default;

    //this.EventInterval = setInterval(this.findMarket(), 1000);

  },
  watch: {
    '$router.query' (p) {
      this.fetchMarket()
      this.selected = this.default;
      this.findMarket()
    },
    'markets' () {
      this.findMarket()
    },
    'sport' () {
      this.fetchMarket()
    },
    'selected' () {
      this.findMarket()
    },
    'default' () {
      this.selected = this.default;
    },
    '$store.state.sport' (v) {
      setTimeout(() => {
        this.$store.commit("updateMarketSelect", this.s);
      },100)
    },
  },
  methods: {
    findMarket(){
      this.markets.forEach(value => {

          if(value.e == this.selected){
            //this.$bus.$emit('selectedMarket'+this.id, value );

            //this.$set(this.$store.state, 'selectedMarket'+this.id, value);

            this.s = {market: value, cell: this.id, onLive: this.live}

            this.$store.commit("updateMarketSelect", {market: value, cell: this.id, onLive: this.live});

          }
      })
    },
    fetchMarket(){

      var key = (this.live) ? 'l' : 'p';
      key = 'm_'+this.sport+key

      if(typeof window.markets[key] === 'undefined'){

        var sport = this.sport

        if(this.sport == 17 || this.sport == 9)
          sport = 1

        this.$http.get(bsapi+'api/v2/fixture/main-market/'+sport+'?isLive='+this.live+'&locale='+window.locale
        ).then(response => {
          this.markets = response.body;
          window.markets[key] = response.body;

        })
      }else {
        setTimeout(() => {
          this.markets = window.markets[key];
        },100)
      }

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/sportsbook/marketSelect.vue